// extracted by mini-css-extract-plugin
export default {"home":"c-c_ea","home__content":"c-c_eb"};